import React from 'react';
import { StaticConnectionsHero } from '../components/StaticConnectionsHero';
import { RecapsFeed } from '../components/RecapsFeed';
import { SlackIntegrationGraphCardMorph } from '../components/SlackIntegrationGraphCardMorph';
import { GettingStartedSteps } from '../components/GettingStartedSteps';
import { AudienceSwitch } from '../components/AudienceSwitch';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { ComputerUse } from '../components/ComputerUse';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { ClosingCTA } from '../components/ClosingCTA';
export function HomeAlternative() {
  return <>
      {/* 1. New static hero with logo carousel */}
      <StaticConnectionsHero data-id="element-9590" data-mp="vystf8r8mns6" />

      {/* 2. "The Giga that came up in my emails today" - showing examples of work */}
      <section className="w-full bg-[#FAF8F4] py-24 md:py-32 border-b border-neutral-200/70" data-id="element-9591" data-mp="qxn0paxkv0in">
        <div className="max-w-[1280px] mx-auto px-6 md:px-10" data-id="element-9592" data-mp="2lsjdzgs6c5un">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-9593" data-mp="2qr33fr5z7zrr">
            <h2 className="text-3xl md:text-5xl font-title font-medium text-[#2B211A] tracking-tight leading-[1.1] mb-6" data-id="element-9594" data-mp="2cr22yctmiuct">
              The Giga that came up in my emails today
            </h2>
            <p className="text-lg text-neutral-500" data-id="element-9595" data-mp="2hrzfa8rycu6e">
              A look at the different types of work Giga can handle across your
              organization, quietly running in the background.
            </p>
          </div>
          <RecapsFeed data-id="element-9596" data-mp="1u13sjq2csp60" />
        </div>
      </section>

      {/* 3. Roll right into works in your chats */}
      <SlackIntegrationGraphCardMorph data-id="element-9597" data-mp="1y1e0v9dmbro1" />

      {/* Rest of the home page */}
      <GettingStartedSteps data-id="element-9598" data-mp="1k2o27pb5hjxk" />
      <AudienceSwitch data-id="element-9599" data-mp="1k3fna674fz9l" />
      <CapabilityGrid data-id="element-9600" data-mp="1k2wfhib6qr9a" />
      <ComputerUse data-id="element-9601" data-mp="1k4qpw2otz0z4" />
      <NarrativeSection data-id="element-9602" data-mp="1p17r9yl1jbu5" />
      <ToolComparison data-id="element-9603" data-mp="1p0ftch3z120p" />
      <WallOfLove data-id="element-9604" data-mp="1p0xzq6kckwmc" />
      <ClosingCTA data-id="element-9605" data-mp="1p3k2zu07gpyr" />
    </>;
}